<mat-dialog-content>
  <div class="message" [innerHTML]='safeHtml'></div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-raised-button (click)="onOK()">OK</button>
</mat-dialog-actions>
